import { isArray, isObject, isUndefined, forEach } from "lodash";
import { ENTRYPOINT } from "../config/entrypoint";
import SubmissionError from "../error/SubmissionError";
// import { normalize } from './hydra';
import get from "lodash/get";
import has from "lodash/has";
import mapValues from "lodash/mapValues";

const MIME_TYPE = "application/ld+json";

const transformRelationToIri = (payload) => {
  forEach(payload, (value, property) => {
    if (isObject(value) && !isUndefined(value["@id"])) {
      payload[property] = value["@id"];
    }

    if (isArray(value)) payload[property] = transformRelationToIri(value);
  });

  return payload;
};

const makeParamArray = (key, arr) =>
  arr.map((val) => `${key}[]=${val}`).join("&");

// START:CUSTOM - generated
const normalize = (data) => {
  if (has(data, "hydra:member")) {
    // Normalize items in collections
    data["hydra:member"] = data["hydra:member"].map((item) => normalize(item));

    return data;
  }

  // Flatten nested documents
  return mapValues(data, (value) =>
    Array.isArray(value)
      ? value.map((v) => get(v, "@id", v))
      : get(value, "@id", value)
  );
};
// END:CUSTOM - generated

export default function (id:any, options = {}, token = null) {
  if ("undefined" === typeof options.headers) options.headers = new Headers();

  if (null === options.headers.get("Accept"))
    options.headers.set("Accept", MIME_TYPE);

  if (
    "undefined" !== options.body &&
    !(options.body instanceof FormData) &&
    null === options.headers.get("Content-Type")
  )
    options.headers.set("Content-Type", MIME_TYPE);

  // START:CUSTOM - generated
  //add authorization token
  if (token) {
    //token is passed as param because rootState is not accessble and useStore should not be used here
    options.headers.set("Authorization", `Bearer ${token}`);
  }
  // END:CUSTOM - generated

  const payload = options.body && JSON.parse(options.body);
  if (isObject(payload) && payload["@id"])
    options.body = JSON.stringify(transformRelationToIri(payload));

  if (options.params) {
    const params = normalize(options.params);
    let queryString = Object.keys(params)
      .map((key) =>
        Array.isArray(params[key])
          ? makeParamArray(key, params[key])
          : `${key}=${params[key]}`
      )
      .join("&");
    id = `${id}.jsonld?${queryString}`;
  }

  return fetch(new URL(id, ENTRYPOINT), options).then((response) => {
    if (response.ok) return response;

    return response.json().then((json) => {
      const error = json["hydra:description"] || response.statusText;
      if (!json.violations) throw Error(error);

      let errors = { _error: error };
      json.violations.map(
        (violation) => (errors[violation.propertyPath] = violation.message)
      );

      throw new SubmissionError(errors);
    });
  });
}
